import { FC, useCallback, useEffect, useState } from "react";
import { Colors } from "../../styles/constant";
import {
  Box,
  Button,
  Checkbox,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CustomLink from "../CustomLink/CustomLink";
import { defaultEmptyFun, updateNPSSessionStorage } from "../../utils/helper";
import {
  useLazyNpsZoneDetailsLiQuery,
  useLazySaveNpsFeedbackLiQuery,
} from "../../features/Feature_LifeInsurance/LifeInsurance_Api";
import {
  NpsZoneDetailsResponse,
  T_FetchPolicyDetails_Response,
} from "../../features/Feature_LifeInsurance/LifeInsurance_Types";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import {
  T_ApiResponse,
  T_LiRouteState,
  T_AnimationData,
} from "../../globalTypes/GlobalTypes";
import { useLocation } from "react-router-dom";
import CustomPopup from "../CustomPopup/CustomPopup";
import CommonGifAnimation from "../../components/CustomGifAnimation/CommonGifAnimation";
import SuccessGif from "../../assets/gif/Success.json";
import { useDispatch } from "react-redux";
import { setError } from "../../redux-store/reducers/CsErrorSlice";
import { triggerCleverTapEvent } from "../../utils/CleverTap";
import TriggerGTAEvent from "../../utils/GTA";
import {
  GTAScreenType,
  SCREEN_TYPE,
  DEVICE_TYPE,
  staticTitleText,
  subTitleMainText,
  subTitleSpanText,
  staticTextBoxValue,
} from "../../utils/constants";
import { useLazyGenAppSaveNpsFeedbackQuery } from "../../features/Feature_GeneralAppElements/GeneralAppElements_Api";
import useDeviceDetection from "../../hooks/useDeviceDetection";
import { useLazyFetchNpsFeedbackQuery } from "../../features/Features_Cms/Cms_Api";
import { API_STATUS_CODE } from "../../utils/ApiEndpoints";
import { T_CmsNpsFeedback } from "../../features/Features_Cms/CmsGlobal.Types";
import { setSelectedTaxCenterFlow } from "../../features/Feature_GeneralAppElements/GeneralAppElements_Slice";
import ExtendedFeedbackPopup from "./ExtendedFeedbackPopup";
import { isEmpty } from "lodash";
import { nativeCallBackMethodForAppReview } from "../../utils/NativeAppEvents";
import { useAppTranslation } from "../../hooks/useAppTranslation";
import CustomCircularLoader from "../CustomCircularLoader/CustomCircularLoader";

interface CheckList {
  label: string;
  isChecked: boolean;
}
declare const window: any;

const feedbackNumberList = [
  { number: 0, color: Colors.vermilion },
  { number: 1, color: Colors.vermilion },
  { number: 2, color: Colors.vermilion },
  { number: 3, color: Colors.vermilion },
  { number: 4, color: Colors.vermilion },
  { number: 5, color: Colors.vermilion },
  { number: 6, color: Colors.vermilion },
  { number: 7, color: Colors.iconYellow },
  { number: 8, color: Colors.iconYellow },
  { number: 9, color: Colors.cadmiumGreen },
  { number: 10, color: Colors.cadmiumGreen },
];

interface Props {
  linkOnClick?: any;
  btnOnClick?: any;
  selectedPolicyId?: string;
  module?: string;
  mode?: string;
  value?: string;
  lobId?: string;
  holdingIdentifier?: string;
  functionalityCode?: string;
}

const CommonFeedbackPopupBody: FC<Props> = ({
  linkOnClick = defaultEmptyFun,
  btnOnClick = defaultEmptyFun,
  selectedPolicyId,
  module,
  mode,
  value,
  lobId,
  holdingIdentifier,
  functionalityCode,
}) => {
  const { t } = useAppTranslation("common");
  const handleClevertapCTAClick = () => {
    triggerCleverTapEvent("li_serv_feedback_submit_click", {
      ScreenType: SCREEN_TYPE.LIScreenType,
      ScreenName: "Life Insurance Servicing Experience Feedback Enter Screen",
      isPrevPageNameRequired: true,
      ctaText: "submit",
      OptionSelected: feedbackString,
      QuestionText: feedbackTextValue,
      MainCategory: "download_statements",
      SubCategory: module,
    });
  };
  const [feedbackRate, setFeedbackRate] = useState<number | null>(null);
  const [feedbackTextValue, setFeedbackTextValue] = useState<string>("");
  const [nspZoneResponse, setNspZoneResponse] =
    useState<NpsZoneDetailsResponse | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [feedbackPopupOpen, setfeedbackPopupOpen] = useState<boolean>(true);
  const [isBtnLoading, setIsBtnLoading] = useState<boolean>(false);
  const [checkList, setCheckList] = useState<CheckList[]>([
    { label: t("feedback.options.easeOfLogin"), isChecked: false },
    { label: t("feedback.options.easeOfTransaction"), isChecked: false },
    { label: t("feedback.options.timeTakenToRespond"), isChecked: false },
    {
      label: t("feedback.options.accuracyAndCompletenessOfInformation"),
      isChecked: false,
    },
  ]);
  const [liSaveNpsFeedbackApi] = useLazySaveNpsFeedbackLiQuery();
  const [liNpsZoneDetailsApi] = useLazyNpsZoneDetailsLiQuery();
  const [GenAppSaveNpsFeedbackApi] = useLazyGenAppSaveNpsFeedbackQuery();
  const [feedbackApiSuccess, setFeedbackApiSuccess] = useState<boolean>(false);
  const [fetchNpsFeedback] = useLazyFetchNpsFeedbackQuery();
  const [npsCms, setNpsCms] = useState<T_CmsNpsFeedback>();
  const [openExtendedFeedbackPopup, setOpenExtendedFeedbackPopup] =
    useState<boolean>(false);

  const { state } = useLocation();
  const dispatch = useDispatch();
  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const { taxCenterFlow } = useAppSelector(
    (state) => state.GeneralAppElementsSlice,
  );

  const policyNumber =
    selectedPolicyId || (state as T_LiRouteState)?.policyNumber || "";
  const policyDetails = useAppSelector(
    (state) => state.LifeInsuranceSlice.policyDetails,
  );

  const selectedPolicyDetails = policyDetails?.find(
    (item: T_FetchPolicyDetails_Response) => {
      return item?.PolicyDetails?.POL_ID === policyNumber;
    },
  );
  const deviceType = useDeviceDetection();

  // Step 1: Filter the items where isChecked is true
  const checkedItems = checkList.filter((item) => item.isChecked);

  // Step 2: Extract the labels from the filtered items
  const feedbackReasons = checkedItems.map((item) => item.label);

  // If you want feedback as a string with labels separated by commas
  const feedbackString = feedbackReasons.join(", ");
  const handleClosePopupHandle = () => {
    setTimeout(() => {
      setOpen(false);
      linkOnClick();
      if (taxCenterFlow) {
        dispatch(setSelectedTaxCenterFlow(""));
      }
      // navigate(-1);
    }, 5000);
  };
  const NpsZoneDetailsIntegration = () => {
    let reqBodyforNpsZoneDetails = {
      policyId: selectedPolicyId || "",
    };
    liNpsZoneDetailsApi(reqBodyforNpsZoneDetails).then((res) => {
      if (res.data?.code === 1) {
        setNspZoneResponse(res.data?.payload?.Response[0]);
      }
    });
  };
  useEffect(() => {
    fetchNpmCms();
  }, []);

  const fetchNpmCms = async () => {
    try {
      const response = await fetchNpsFeedback();
      if (response.data?.code === API_STATUS_CODE.SUCCESS) {
        setNpsCms(response.data.payload.data);
        let checkList =
          response.data.payload?.data.attributes?.checkBox?.map((item) => ({
            label: item.title,
            isChecked: false,
          })) ?? [];

        if (checkList.length > 0) {
          setCheckList(checkList as CheckList[]);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!lobId) {
      NpsZoneDetailsIntegration();
    }
  }, [selectedPolicyId, lobId]);
  // Get current date and time
  const currentDate = new Date();
  // Convert to Unix timestamp (seconds)
  const unixTimestampInSeconds = Math.floor(currentDate.getTime() / 1000);
  // const currentTime = currentDate.toISOString().slice(0, 19).replace("T", " ");
  // const getCurrentDateTime = (): string => {
  //   const currentDate = new Date();
  //   return currentDate.toISOString().slice(0, 19).replace("T", " ");
  // };

  // Get the components
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");

  // Format the date and time
  const currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  // console.log(currentTime);

  const btnClick = () => {
    checkList.forEach((item) => {
      if (item.isChecked) {
        TriggerGTAEvent("li_serv_feedback_submit_click", {
          screen_type: GTAScreenType.LIScreenType,
          screen_name:
            "life_insurance_servicing_experience_feedback_enter_screen",
          step_title: "download_statements",
          sub_step_title: "tax_certificate",
          question_text: feedbackTextValue,
          option_selected: item.label,
          CTA_text: "submit",
        });
      }
    });

    handleClevertapCTAClick();
    setIsBtnLoading(true);
    let reqBodyforSaveNpsFeedback = {
      cust_id: selectedPolicyDetails?.PolicyDetails?.CLIENT_ID || "",
      fdate: unixTimestampInSeconds,
      rdate: unixTimestampInSeconds,
      nps: feedbackRate?.toString() || "",
      comments: feedbackTextValue,
      policy_no: selectedPolicyDetails?.PolicyDetails?.POL_ID || "",
      transaction_type: module || "",
      transaction_date: unixTimestampInSeconds,
      sales_channel: nspZoneResponse?.sales_channel || "",
      utceid: "",
      product_type: nspZoneResponse?.type || "",
      zone: nspZoneResponse?.zone,
      region: nspZoneResponse?.reptng_loc_name || "",
      transaction_bc: nspZoneResponse?.ca_branch_code || "",
      name: nspZoneResponse?.customer_name || "",
      phone_m1: nspZoneResponse?.mobile || "",
      mail_1: nspZoneResponse?.email || "",
      age: nspZoneResponse?.current_age.toString() || "",
      occupation: nspZoneResponse?.occupation || "",
      source_bc: nspZoneResponse?.lead_gen_code,
      policy_issue_date: nspZoneResponse?.pol_iss_eff_dt || "",
      feedback_source: mode || "",
      feedback_reasons: feedbackString,
    };

    liSaveNpsFeedbackApi(reqBodyforSaveNpsFeedback).then((res) => {
      setIsBtnLoading(false);
      if (res.data?.code === 1) {
        setFeedbackApiSuccess(true);
        updateNPSSessionStorage(value, mode);

        //conditionally open the extended feedback  popup
        if (feedbackRate !== null) {
          if (
            feedbackRate >= 8 &&
            !isEmpty(csAppSlice?.NativeDeviceInfo?.deviceName)
          ) {
            //Open extended popup for ratings 8, 9, 10 and mobile app
            setOpenExtendedFeedbackPopup(true);
          } else {
            // Open feedback success popup as existing
            setOpen(true);
            handleClosePopupHandle();
          }
        }
      }
      if (res.isError && res.error) {
        dispatch(
          setError({
            error: res.error as T_ApiResponse<any>,
            message: "failed",
          }),
        );
      }
    });
  };

  const SubmitFeedback = () => {
    setIsBtnLoading(true);

    GenAppSaveNpsFeedbackApi({
      feedbackDate: currentTime,
      nps: feedbackRate?.toString() || "",
      comments: feedbackTextValue,
      holdingIdentifier: holdingIdentifier || "",
      functionalityCode: functionalityCode || "",
      lobId: lobId || "",
      transactionType: module || "",
      transactionDate: currentTime,
      casetype: "",
      casesubsubtype: "",
      caseNo: "",
      issuetype: "",
      name: userDetails?.name || "",
      mobile: userDetails?.mobileNumber || "",
      email: userDetails?.emailId || "",
      age: "",
      feedbackSource:
        deviceType === DEVICE_TYPE.MOBILE ||
        deviceType === DEVICE_TYPE.PWA_MOBILE
          ? "One Customer Portal Mobile"
          : "One Customer Portal Web",
      feedbackReasons: feedbackString,
    }).then((res) => {
      setIsBtnLoading(false);
      if (res.data?.code === 1) {
        setFeedbackApiSuccess(true);
        updateNPSSessionStorage(value, mode);
        //conditionally open the extended feedback  popup
        if (feedbackRate !== null) {
          if (
            feedbackRate >= 8 &&
            !isEmpty(csAppSlice?.NativeDeviceInfo?.deviceName)
          ) {
            //Open extended popup for ratings 8, 9, 10 and mobile app
            if (csAppSlice.NativeDeviceInfo?.systemName === "Android") {
              const message = {
                action: "inAppReview",
              };
              if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify(message));
                console.log(
                  "Sending event to TWA React Native Android " +
                    JSON.stringify(message),
                );
              }
            } else {
              nativeCallBackMethodForAppReview({
                type: "inAppReview",
              })
                .then((response: any) => {
                  console.log("Response from native code:", response);
                  setOpenExtendedFeedbackPopup(true);
                })
                .catch((error) => {
                  console.log("Response from native code:", error);
                });
            }
          } else {
            // Open feedback success popup as existing
            setOpen(true);
            handleClosePopupHandle();
          }
        }
      }
      if (res.isError && res.error) {
        dispatch(
          setError({
            error: res.error as T_ApiResponse<any>,
            message: "failed",
          }),
        );
      }
    });
  };

  const handleClosePopup = useCallback(() => {
    TriggerGTAEvent("li_serv_feedback_skip_cta_click", {
      screen_type: GTAScreenType.LIScreenType,
      screen_name: "life_insurance_servicing_experience_feedback_enter_screen",
      step_title: "download_statements",
      sub_step_title: "tax_certificate",
      CTA_text: "skip",
    });
    setFeedbackRate(null);
    setFeedbackTextValue("");
    linkOnClick();
    if (taxCenterFlow) {
      dispatch(setSelectedTaxCenterFlow(""));
    }
  }, [linkOnClick]);

  const handleCheckBoxClick = useCallback((label: string) => {
    setCheckList((prevState: CheckList[]) => {
      let tempState = [...prevState];
      tempState.forEach((item) => {
        if (item.label === label) {
          item.isChecked = !item.isChecked;
        }
      });
      return tempState;
    });
  }, []);

  const renderFeedbackNumberBox = (item: { number: number; color: string }) => (
    <Box
      key={item?.number}
      className={`feedback-number-box ${
        feedbackRate === item?.number ? "Selected" : ""
      }`}
      sx={{ backgroundColor: item?.color }}
      onClick={() => setFeedbackRate(item?.number)}
    >
      {item?.number}
      {feedbackRate === item?.number && (
        <CheckCircleIcon className="right-icon" />
      )}
    </Box>
  );

  let isBtnDisabled = feedbackRate === null || feedbackRate === undefined;

  return (
    <>
      {feedbackPopupOpen && (
        <>
          <Box className="feedback-wrapper">
            <Box>
              <Typography
                textAlign="center"
                letterSpacing=".0938rem"
                variant="h5"
                sx={{ marginTop: "2rem" }}
              >
                {t("feedback.headings.title") || npsCms?.attributes?.title}
              </Typography>
              <Typography
                marginTop="1rem"
                textAlign="center"
                fontSize={14}
                fontWeight={500}
                color="#979797"
                lineHeight=".9625rem"
              >
                {t("feedback.headings.subtitle")}
                <span
                  style={{
                    fontSize: ".875rem",
                    fontWeight: 500,
                    lineHeight: "100%",
                    textAlign: "center",
                    color: Colors.darkCharcoal,
                  }}
                >
                  {t("feedback.headings.spanSubtitle")}
                </span>
              </Typography>
              <Stack
                marginTop="1.875rem"
                flexDirection="row"
                justifyContent="center"
                gap=".4375rem"
              >
                {feedbackNumberList.slice(0, 5).map(renderFeedbackNumberBox)}
              </Stack>
              <Stack
                marginTop=".9375rem"
                flexDirection="row"
                justifyContent="center"
                gap=".4375rem"
              >
                {feedbackNumberList.slice(5, 11).map(renderFeedbackNumberBox)}
              </Stack>
              <Typography
                marginTop="1.875rem"
                textAlign="center"
                fontSize={14}
                fontWeight={500}
                color="#979797"
                lineHeight=".9625rem"
              >
                {t("feedback.headings.middleTitle")}
              </Typography>
              <Box marginTop=".625rem">
                {checkList.map((item: CheckList) => (
                  <Box
                    display="flex"
                    alignItems="center"
                    key={item.label}
                    marginTop={".3125rem"}
                  >
                    <Checkbox
                      size="small"
                      checked={item.isChecked}
                      onChange={() => handleCheckBoxClick(item.label)}
                      sx={{
                        padding: 0,
                        "&.Mui-checked": {
                          color: Colors.red,
                        },
                      }}
                    />
                    <Typography
                      marginLeft=".5rem"
                      fontSize={14}
                      fontWeight={400}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                ))}
              </Box>
              <TextField
                multiline
                fullWidth
                minRows={3}
                value={feedbackTextValue}
                onChange={(e) => setFeedbackTextValue(e.target.value)}
                className="feedback-text-area"
                placeholder={
                  t("feedback.headings.textboxLabel") ||
                  npsCms?.attributes?.textFieldPlaceholder
                }
              />
            </Box>
          </Box>
          <Box
            className="feedback-footer"
            sx={{
              marginTop: "auto",
            }}
          >
            <Button
              fullWidth
              variant="contained"
              disabled={isBtnDisabled}
              className="popup-btn"
              onClick={lobId ? SubmitFeedback : btnClick}
            >
              {isBtnLoading ? (
                <CustomCircularLoader size={20} color="white" />
              ) : (
                t("feedback.actionButtons.submit")
              )}
            </Button>
            <Box display="flex" justifyContent="center" marginTop=".9375rem">
              <CustomLink
                title={t("feedback.actionButtons.skip")}
                titleSize={".75rem"}
                onClick={handleClosePopup}
              />
            </Box>
          </Box>
        </>
      )}
      <CustomPopup open={open} handleOpen={handleClosePopupHandle}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            marginLeft: "1rem",
            marginRight: "1rem",
            marginBottom: "2rem",
          }}
        >
          <CommonGifAnimation
            animationData={SuccessGif as T_AnimationData}
            width="15.625rem"
          />
          <Typography variant="subtitle2" marginBottom=".625rem">
            {t("feedback.successMessages.thankYouForYourFeedback")}
          </Typography>
        </Box>
      </CustomPopup>

      <ExtendedFeedbackPopup
        open={openExtendedFeedbackPopup}
        handleClose={handleClosePopup}
      />
    </>
  );
};

export default CommonFeedbackPopupBody;
